<template>
  <card>
    <form @submit.prevent="updateProfile">
      <div slot="header">
        <h5 class="title d-inline-block">Modifier votre profil</h5>
        <base-button
          native-type="submit"
          type="primary"
          class="btn-fill btn-sm float-right"
        >
          Enregistrer
        </base-button>
      </div>
      <tabs type="info">
        <tab-pane label="Capital et cash">
          <div>
            <div class="row">
              <div class="col-md-3">
                <base-input
                  name="initialCapital"
                  required
                  label="Capital initial"
                  placeholder="15000"
                  v-model="model.initialCapital"
                  v-validate="modelValidations.initialCapital"
                  :error="getError('initialCapital')"
                  addon-left-icon="tim-icons icon-money-coins"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  name="cash"
                  required
                  label="Cash disponible"
                  placeholder="2345"
                  v-model="model.cash"
                  v-validate="modelValidations.cash"
                  :error="getError('cash')"
                  addon-left-icon="tim-icons icon-money-coins"
                ></base-input>
              </div>
              <div class="col-md-6">
                <small
                  >Ces deux valeurs permettent de calculer la performance totale
                  réalisée sur votre compte, l'historique de vos performances et
                  le pourcentage de liquidité.</small
                >
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 col-md-4 text-center text-md-left mb-3 mb-md-0"
              >
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Single Select"
                  v-model="model.experience"
                >
                  <el-option
                    v-for="option in experiences"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-8 text-left">
                <div v-if="model.experience == 1">
                  Je découvre les marchés financiers et souhaite y investir pour
                  obtenir un rendement intéressant.
                </div>
                <div v-if="model.experience == 2">
                  J'ai déjà au moins deux ans d'expériences et je connais les
                  marchés financiers. Je sais manipuler les différents types
                  d'ordres.
                </div>
                <div v-if="model.experience == 3">
                  J'ai plusieurs années d'expériences, et j'ai vécu des périodes
                  de crises. J'ai un money management et des règles strictes.
                </div>
              </div>
              <div class="col-12 text-center mt-2">
                <button
                  @click="applyExperience"
                  type="button"
                  class="btn btn-info btn-sm btn-simple"
                >
                  Appliquer le filtrage recommandé
                </button>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane label="Mes valeurs">
          <div>
            <div class="row">
              <div class="col-12">
                <h4 class="mb-1">Vous ne trouvez pas une instrument ?</h4>
                <p>
                  Ajouter vos propres instruments et mettez à jours et mettez à
                  jour leurs valeurs manuellement pour avoir un suivi complet de
                  votre portefeuille.<br />
                </p>
                <div v-if="!conf.isPro" class="text-center mt-4">
                  Les instruments personnalisés sont disponibles pour les
                  utilisateurs Pro.<br />
                  <router-link class="pointer text-primary" tag="b" to="/pro">
                    En savoir plus.
                  </router-link>
                </div>
              </div>
            </div>
            <div>
              <h4 class="mb-1 mt-5">Ajouter une valeur</h4>
              <div class="row">
                <div class="col-md-3">
                  <base-input
                    name="newValueName"
                    required
                    label="Nom de la valeur"
                    placeholder="Nom de la valeur"
                    v-model="model.newValueName"
                  ></base-input>
                </div>
                <div class="col-md-3">
                  <base-input
                    name="newValueSymbol"
                    required
                    label="Symbole / Nom court"
                    placeholder="ALTOTO"
                    v-model="model.newValueSymbol"
                  ></base-input>
                </div>
                <div class="col-md-3">
                  <base-input
                    name="newValueId"
                    required
                    label="Identifiant unique"
                    placeholder="ISIN / ID / ..."
                    v-model="model.newValueId"
                  ></base-input>
                </div>
                <div class="col-md-3 pt-4">
                  <button
                    type="button"
                    class="btn btn-info btn-sm btn-simple"
                    @click="addNewValue"
                  >
                    Ajouter
                  </button>
                </div>
              </div>
              <div class="row" v-if="conf.isPro">
                <div class="col-12 mt-5">
                  <h4 class="mb-1">Modifier mes valeurs</h4>
                  <base-table :data="conf.vals" thead-classes="text-primary">
                    <template slot="columns" slot-scope="{ columns }">
                      <th class="text-center">
                        Nom
                      </th>
                      <th class="text-center">
                        Identifiant
                      </th>
                      <th class="text-center">
                        Symbole
                      </th>
                      <th class="text-center">
                        Prix
                      </th>
                      <th class="text-center">
                        Actions
                      </th>
                    </template>
                    <template slot-scope="{ row, index }" v-if="row">
                      <td class="">{{ row.na }}</td>
                      <td class="">{{ row.sy }}</td>
                      <td class="">{{ row.isin }}</td>
                      <td class="text-center">
                        {{
                          row.v
                            | currency({
                              symbol: $currency(mode)
                            })
                        }}&nbsp;<i
                          class="text-warning pointer tim-icons icon-pencil"
                          @click="editCustomValue(row)"
                        ></i>
                      </td>
                      <td class="text-center">
                        <i
                          class="text-warning pointer tim-icons icon-trash-simple"
                          @click="removeCustomValue(row)"
                        ></i>
                      </td>
                    </template>
                  </base-table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-5">
                <p class="text-muted mt-4">
                  Vous avez besoin d'un suivi automatique d'une valeur ? <br />
                  <b>Contactez-nous sur Twitter.</b>
                </p>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane label="Affichage">
          <div class="row">
            <div class="col-12 text-left">
              <base-switch v-model="model.hideStop">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">Cacher les stops</span>
            </div>
          </div>
        </tab-pane>

        <tab-pane label="Filtres" v-if="mode === 'pea'">
          <p class="text-primary">
            <b>{{ this.livelist.length }}</b> instruments accessibles avec le
            filtrage actuel.
          </p>
          <div class="row mt-2">
            <div class="col-12">
              <h3 class="mb-1">Prix et volumes</h3>
            </div>
            <div class="col-12 col-md-3">
              <base-input
                name="minimumVolume"
                :label="
                  'Volumes moyens minimum par jour (' +
                    (mode === 'pea' ? '€' : '$') +
                    ')'
                "
                v-model="model.minimumVolume"
                v-validate="modelValidations.minimumVolume"
                :error="getError('minimumVolume')"
                addon-left-icon="tim-icons icon-money-coins"
              ></base-input>
            </div>
            <div class="col-12 col-md-3">
              <base-input
                name="maximumVolume"
                :label="
                  'Volumes moyens maximum par jour (' +
                    (mode === 'pea' ? '€' : '$') +
                    ')'
                "
                v-model="model.maximumVolume"
                v-validate="modelValidations.maximumVolume"
                :error="getError('maximumVolume')"
                addon-left-icon="tim-icons icon-money-coins"
              ></base-input>
            </div>
            <div class="col-12 col-md-6">
              <small
                >Filtrer les volumes permet cacher des valeurs peu liquides, ou
                d'éliminer les grosses capitalisations de vos recherches.</small
              >
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md-3">
              <base-input
                name="minimumValue"
                :label="
                  'Valeur minimum d\'un instrument (' +
                    (mode === 'pea' ? '€' : '$') +
                    ')'
                "
                v-model="model.minimumValue"
                v-validate="modelValidations.minimumValue"
                :error="getError('minimumValue')"
                addon-left-icon="tim-icons icon-money-coins"
              ></base-input>
            </div>
            <div class="col-12 col-md-3">
              <base-input
                name="maximumValue"
                :label="
                  'Valeur maximum d\'un instrument (' +
                    (mode === 'pea' ? '€' : '$') +
                    ')'
                "
                v-model="model.maximumValue"
                v-validate="modelValidations.maximumValue"
                :error="getError('maximumValue')"
                addon-left-icon="tim-icons icon-money-coins"
              ></base-input>
            </div>
            <div class="col-12 col-md-6">
              <small
                >Filtrer le prix des actions permet de cacher des valeurs type
                Penny Stocks, ou d'éliminer les valeurs qui vous semble trop
                chères.</small
              >
            </div>

            <div class="col-12">
              <h3 class="mt-3 mb-1">Filtres avancés</h3>
            </div>

            <div class="col-12 text-left">
              <base-switch v-model="model.displayETF">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">Afficher les ETFs (Trackers)</span>
            </div>
            <div class="col-12 text-left mt-2">
              <base-switch v-model="model.displayFund">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">Afficher les fonds</span>
            </div>
            <div class="col-12 text-left mt-2">
              <base-switch v-model="model.displayNoQuotes">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">Afficher les titres suspendus</span>
            </div>
            <div class="col-12 text-left mt-2">
              <base-switch v-model="model.displayBearish">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >Afficher les valeurs fortement baissières</span
              >
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h3 class="mt-3 mb-1">Places de marché</h3>
            </div>
            <div class="col-12 text-left">
              <base-switch v-model="model.places.etfp">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🤖 [ETFP] Electronic ETF, ETC/ETN and Open-End Funds
                Market</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.mtaa">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🤖 [MTAA] Electronic Share Market</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.tnlb">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇧🇪 [TNLB] Euronext - Trading Facility Brussels</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xaim">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇮🇹 [XAIM] AIM Italia - Mercato Alternativo Del Capitale</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xams">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇳🇱 [XAMS] Euronext - Euronext Amsterdam</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xbru">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇧🇪 [XBRU] Euronext - Euronext Brussels</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xdub">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇮🇪 [XDUB] Irish Stock Exchange - All Market</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xetr">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">🇩🇪 [XETR] Xetra</span>
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xhel">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">🇫🇮 [XHEL] Nasdaq Helsinki Ltd</span>
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xlis">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇵🇹 [XLIS] Euronext - Euronext Lisbon</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xlon">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🏴󠁧󠁢󠁥󠁮󠁧󠁿 [XLON] London Stock Exchange</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xlux">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇱🇺 [XLUX] Luxembourg Stock Exchange</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xmad">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">🇪🇸 [XMAD] Bolsa De Madrid</span>
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xpar">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top"
                >🇫🇷 [XPAR] Euronext - Euronext Paris</span
              >
            </div>
            <div class="col-12 text-left mt-1">
              <base-switch v-model="model.places.xwbo">
                <i class="tim-icons icon-check-2" slot="on"></i>
                <i class="tim-icons icon-simple-remove" slot="off"></i>
              </base-switch>
              <span class="ml-3 align-top">🇦🇹 [XWBO] Wiener Boerse AG</span>
            </div>
          </div>
        </tab-pane>

        <tab-pane label="Zone à risque">
          <div class="row">
            <div class="col-12 text-center mt-2 text-danger">
              Attention, vous êtes dans la zone à risque, les actions de cet
              onglet sont irréversibles.
            </div>
            <div
              class="col-12 text-center mt-4"
              v-if="conf.history && conf.history.length"
            >
              <button
                @click="cleanHistory"
                type="button"
                class="btn btn-danger btn-sm "
              >
                Supprimer l'historique des mes performances
              </button>
              <p>
                Votre historique contient {{ conf.history.length }} entrée{{
                  conf.history.length > 1 ? "s" : ""
                }}.
              </p>
              <p class="pointer text-primary" @click="downloadHisto">
                Télécharger l'historique
              </p>
            </div>
            <div
              class="col-12 text-center mt-4"
              v-if="conf.positions && conf.positions.length"
            >
              <button
                @click="cleanPortfolio"
                type="button"
                class="btn btn-danger btn-sm "
              >
                Vider mon portefeuille
              </button>
              <p>
                Votre portefeuille contient {{ conf.positions.length }} valeur{{
                  conf.positions.length > 1 ? "s" : ""
                }}.
              </p>
            </div>
            <!-- <div class="col-12 text-center mt-4">
              <button @click="cleanAccount" type="button" class="btn btn-danger btn-sm ">
                Supprimer mon compte
              </button>
              <p>Cette action supprimera toutes vos données et votre compte.</p>
            </div> -->
          </div>
        </tab-pane>
      </tabs>

      <base-button
        native-type="submit"
        type="primary"
        class="btn-fill btn-sm float-right"
      >
        Enregistrer
      </base-button>
    </form>
  </card>
</template>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import { Select, Option } from "element-ui";
import { getFilers } from "../../../util/filterTools";
import { exportCSVFile } from "../../../util/csvUtil";

import { BaseSwitch, TabPane, BaseTable, Tabs } from "src/components/index";

export default {
  components: {
    BaseSwitch,
    TabPane,
    BaseTable,
    Tabs,
    [Option.name]: Option,
    [Select.name]: Select
  },
  computed: {
    ...mapGetters({
      conf: "auth/conf",
      livelist: "instruments/livelist",
      mode: "auth/mode"
    })
  },
  data() {
    return {
      model: {
        newValueName: "",
        newValueId: "",
        newValueSymbol: "",
        initialCapital: 15000,
        cash: 15000,
        hideStop: false,
        displayETF: false,
        displayFund: false,
        displayNoQuotes: false,
        displayBearish: true,
        minimumVolume: null,
        maximumVolume: null,
        minimumValue: null,
        maximumValue: null,
        experience: null,
        places: {
          etfp: true,
          mtaa: true,
          tnlb: true,
          xaim: true,
          xams: true,
          xbru: true,
          xdub: true,
          xetr: true,
          xhel: true,
          xlis: true,
          xlon: true,
          xlux: true,
          xmad: true,
          xpar: true,
          xwbo: true
        }
      },
      experiences: [
        { value: 1, label: "Débutant" },
        { value: 2, label: "Intermédiaire" },
        { value: 3, label: "Expérimenté" }
      ],
      modelValidations: {
        initialCapital: {
          required: true,
          numeric: true
        },
        cash: {
          required: true,
          decimal: true
        },
        minimumVolume: {
          numeric: true
        },
        maximumVolume: {
          numeric: true
        },
        minimumValue: {
          numeric: true
        },
        maximumValue: {
          numeric: true
        }
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    updateProfile() {
      return this.$validator.validateAll().then(res => {
        this.$store.dispatch("auth/updateconf", {
          initialCapital: parseFloat(this.model.initialCapital),
          cash: parseFloat(this.model.cash),
          hideStop: this.model.hideStop || null,
          displayETF: this.model.displayETF || null,
          displayFund: this.model.displayFund || null,
          displayNoQuotes: this.model.displayNoQuotes || null,
          hideBearish: !this.model.displayBearish,
          minimumVolume: this.model.minimumVolume || null,
          maximumVolume: this.model.maximumVolume || null,
          minimumValue: this.model.minimumValue || null,
          maximumValue: this.model.maximumValue || null,
          experience: this.model.experience,
          places: this.model.places
        });

        swal("C'est sauvegardé !", "", "success").then(() => {
          this.$store.dispatch("instruments/getLive", this.mode);
        });

        return res;
      });
    },
    addNewValue() {
      if (!this.conf.isPro) {
        swal(
          "Oups !",
          "Vous devez activer le mode pro pour ajouter des valeurs personnalisées.",
          "error"
        );
        return;
      }
      if (
        this.model.newValueName.length &&
        this.model.newValueId.length &&
        this.model.newValueSymbol.length
      ) {
        this.$store.dispatch("auth/addCustomValue", {
          na: this.model.newValueName,
          isin: this.model.newValueId,
          sy: this.model.newValueSymbol,
          v: 0
        });
      } else {
        swal("Oups !", "Merci de bien remplir tout les champs !", "error");
      }
    },
    editCustomValue(row) {
      this.$swal({
        input: "text",
        inputPlaceholder: "12.34",
        title: `Modifier le prix`,
        text: `Saisissez le nouveau prix de la valeur ${row.na}.`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmer",
        cancelButtonText: "Ignorer",
        showCloseButton: true
      }).then(result => {
        if (result.isConfirmed) {
          const newPrice = parseFloat(result.value.replace(/,/g, "."));
          this.$store.dispatch("auth/editCustomValue", {
            isin: row.isin,
            v: newPrice
          });
        }
      });
    },
    removeCustomValue(row) {
      const index = this.conf.positions.findIndex(p => p.isin === row.isin);
      // Vérifier si valeur présente dans portefeuille
      if (index !== -1) {
        swal(
          "Oups !",
          "Votre valeur est en portefeuille, vous ne pouvez pas la supprimer !",
          "error"
        );
      } else {
        // Sinon, demande de suppression
        this.$swal({
          title: `Suppression`,
          text: `Souhaitez vous supprimer la valeur ${row.na} ?`,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Confirmer",
          cancelButtonText: "Ignorer",
          showCloseButton: true
        }).then(result => {
          if (result.isConfirmed) {
            this.$store.dispatch("auth/deleteCustomValue", row.isin);
          }
        });
      }
    },
    applyExperience() {
      const newFilters = getFilers(this.model.experience);
      this.model = { ...this.model, ...newFilters };

      swal(
        "C'est fait !",
        "Pensez à enregistrer si ces filtres vous conviennent.",
        "success"
      ).then(() => {
        this.$store.dispatch("instruments/getLive", this.mode);
      });
    },
    downloadHisto() {
      const csv =
        "Date;Capital initial;Cash;Total investi\r\n" +
        this.conf.history
          .map(x => {
            return (
              new Date(x.t * 1000).toISOString().slice(0, 10) +
              ";" +
              (+x.ic)
                .toFixed(2)
                .toString()
                .replace(".", ",") +
              ";" +
              (+x.cash)
                .toFixed(2)
                .toString()
                .replace(".", ",") +
              ";" +
              (+x.pos)
                .toFixed(2)
                .toString()
                .replace(".", ",") +
              "\r\n"
            );
          })
          .join("");
      exportCSVFile(csv, "historique-peamoni");
    },
    cleanHistory() {
      swal({
        title: "Attention !",
        text: `Vous êtes sur le point de supprimer l'historique des performances. Cette action est irréversible.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Supprimer l'historique",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("auth/updateconf", {
            history: []
          });
          swal({
            title: "C'est fait!",
            text: "Votre historique est comme neuf.",
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    cleanPortfolio() {
      swal({
        title: "Attention !",
        text: `Vous êtes sur le point de supprimer toutes les valeurs de votre portefeuille. Cette action est irréversible.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Supprimer l'historique",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("auth/updateconf", {
            positions: []
          });
          swal({
            title: "C'est fait!",
            text:
              "Votre portefeuille est comme neuf, pensez à modifier votre couverture disponible.",
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  },
  mounted() {
    if (this.conf) {
      this.model.initialCapital = this.conf.initialCapital;
      this.model.cash = this.conf.cash;
      this.model.hideStop = this.conf.hideStop;
      this.model.displayETF = this.conf.displayETF;
      this.model.displayFund = this.conf.displayFund;
      this.model.displayNoQuotes = this.conf.displayNoQuotes;
      this.model.minimumVolume = this.conf.minimumVolume;
      this.model.maximumVolume = this.conf.maximumVolume;
      this.model.minimumValue = this.conf.minimumValue;
      this.model.maximumValue = this.conf.maximumValue;
      this.model.experience = this.conf.experience;
      this.model.displayBearish = !this.conf.hideBearish;
      if (this.conf.places) this.model.places = this.conf.places;
    }
  },
  watch: {
    conf(newValue, oldValue) {
      if (this.conf) {
        this.model.initialCapital = this.conf.initialCapital;
        this.model.cash = this.conf.cash;
        this.model.experience = this.conf.experience;

        this.model.hideStop = this.conf.hideStop;

        this.model.displayETF = this.conf.displayETF;
        this.model.displayFund = this.conf.displayFund;
        this.model.displayNoQuotes = this.conf.displayNoQuotes;
        this.model.displayBearish = !this.conf.hideBearish;

        this.model.minimumVolume = this.conf.minimumVolume;
        this.model.maximumVolume = this.conf.maximumVolume;
        this.model.minimumValue = this.conf.minimumValue;
        this.model.maximumValue = this.conf.maximumValue;

        if (this.conf.places) this.model.places = this.conf.places;
      }
    }
  }
};
</script>
<style></style>
